import MeetingConnectCard from './MeetingConnectCard';

export default MeetingConnectCard;
